import { batch } from 'react-redux';
import Cookies from 'universal-cookie';
import { isGiftingPages } from 'Utils/PathVerification';
import { getUrlParam } from 'Utils/Content';
import { handleSheerId } from 'Utils/SheerIdHelpers';
import { getConfigApi } from 'Api/ConfigApi';
import { clearEntitlements, getEntitlements } from './User/UserActions';
import { setAppLoading } from './Layouts/LayoutActions';
import { clearSubscription } from './Subscriptions/SubscriptionsActions';
import { clearPaymentMethods } from './PaymentMethods/PaymentMethodActions';
import { clearPaymentHistory } from './Payments/PaymentActions';
import { clearPlans } from './Plans/PlansActions';
import { fetchEventState, resetPurchaseMode } from './PurchaseMode/PurchaseModeActions';
import { resetPromoCode } from './PromoCode/PromoCodeActions';
import { clearCheckout } from './Checkout/CheckoutActions';
import { resetSecondScreen } from './SecondScreen/SecondScreenActions';
import { checkBangoParams, clearBango } from './Integrations/IntegrationsActions';
import { launchAmplitude } from 'Utils/Analytics/Amplitude';
import { setAppConfig } from './AppConfig/AppConfigActions';
import { loadPaypalSDK } from 'Api/PayPal';
import { createProfile } from 'Utils/ProfileSDK';
import { createAuthInstance } from 'Utils/AuthSDK';

const cookie = new Cookies();

const isGiftingMode = getUrlParam('gifting', false);

const locationPath = (window && window.location && window.location.pathname) || '';
const isGiftingRelatedPage = isGiftingMode || isGiftingPages(locationPath);

/*
  for qa only - change to int endpoint config if appropriate
  otherwise stick with the config that's default in this repo's app.json
  */
const setEnvConfig = async (dispatch, defaultConfig) => {
  const { appEnv, integrationEnvConfig } = defaultConfig;

  if (appEnv === 'qa') {
    try {
      const info = await getConfigApi('/info');
      const { baseUrls } = info?.data?.api?.content;

      //cookie is set at https://qa-nation.foxnews.com/debug/api/
      const cookieConfig = cookie.get('DEBUG_PANEL_API_BASEURL') || 'default';

      //if cookie says to use integration environment, use the integration environment config
      if (baseUrls?.[cookieConfig]?.includes(integrationEnvConfig.foxApi)) {
        const newDefaultConfig = { ...defaultConfig, ...GLOBAL_CONFIG.integrationEnvConfig };
        dispatch(setAppConfig({ defaultConfig: newDefaultConfig }));
      }
    } catch (err) {
      console.error(err.message);
    }
  }
};

export const appInit = () => async (dispatch, getState) => {
  const state = getState();
  const {
    user: { isAuthenticated },
  } = state;

  await setEnvConfig(dispatch, state.appConfig.defaultConfig);

  createProfile();
  createAuthInstance();

  await dispatch(fetchEventState(isGiftingRelatedPage));

  await dispatch(checkBangoParams());

  await handleSheerId();

  await launchAmplitude();

  loadPaypalSDK();

  if (isAuthenticated) {
    await dispatch(getEntitlements(1));
  }
  dispatch(setAppLoading(false));
};

export const clearAll = () => (dispatch) => {
  batch(() => {
    dispatch(clearSubscription());
    dispatch(clearEntitlements());
    dispatch(clearPaymentMethods());
    dispatch(clearPaymentHistory());
    dispatch(clearPlans());
    dispatch(resetPurchaseMode());
    dispatch(resetPromoCode());
    dispatch(clearCheckout());
    dispatch(resetSecondScreen());
    dispatch(clearBango());
  });
};
